//@constants
const { EURO_SYMBOL } = require('constants/index');
//@utilities
const { getFormattedString, decimalsLength } = require('utilities/currencyHelper');

module.exports = {
    LOANS_MORTGAGES_MORTGAGE_LOAN: 'mortgage',
    LOANS_MORTGAGES_PAYROLL_LOAN: 'payroll',
    LOANS_MORTGAGES_PERSONAL_LOAN: 'personal',
    LOANS_MORTGAGES_PREAPPROVED_LOAN: 'preapproved',
    LOANS_MORTGAGES_ARES_LOAN: 'ares',
    LOANS_MORTGAGES_RETAIL_LOAN: 'retail',
    STEPS: 'steps',
    YES: 'yes',
    NO: 'no',
    NEWSTEPS: 'newSteps',
    LOANS_MORTGAGES_EASY_LOAN: 'easyLoan',
    LOANS_MORTGAGES_EASY_LOAN_TYPE_C: 'easyLoanTypeC',
    LOANS_INDEX_POSTAL_CODE: 2,
    LOANS_GOOGLE_MAPS_URL: 'https://www.google.com/maps/search/?',
    LOAN_FOUR_LAST_CHARACTERS: 4,
    MAX_LENGTH_NUMBER_INPUT: 8,
    DEFAULT_BEFORE_STEP: 0,
    DEFAULT_LOANS_DECIMALS_LENGTH: 2,
    DEFAULT_VIEWER_HEIGHT: 400,
    PDF_VIEWER_SCALE: 1,
    LOANS_MONTH_AND_YEAR_INPUT: 2,
    WIZARD_FIRST_STEP: 1,
    COLLECTIVE_MOCK_NAME: 'Collective Mock',
    NOT: 'NO',
    MORE_OPTIONS: {
        LOAN_INFORMATION: 'LOAN_INFORMATION',
        MOVEMENTS: 'MOVEMENTS',
        AMORTIZATION_PLAN: 'AMORTIZATION_PLAN',
        PARTIAL_AMORTIZATION: 'PARTIAL_AMORTIZATION',
        LIQUIDATIONS: 'LIQUIDATIONS',
        UNPAID_FEES: 'UNPAID_FEES',
        CHANGE_ACCOUNT: 'CHANGE_ACCOUNT',
        CREDIT_INFORMATION: 'CREDIT_INFORMATION',
        LIMIT_VARIATION: 'LIMIT_VARIATION',
        CANCELLATION: 'CANCELLATION',
        WARRANTIES: 'WARRANTIES',
        SETTLEMENTS: 'SETTLEMENTS'
    },
    LOAN_MORTGAGES_RETAIL_BANNER: "retailLoan",
    URL_TYPEC: "/myprofile/loans-mortgages/contract-easy-loan-typec",
    URL_TYPE_A_B: "/myprofile/loans-mortgages/contract-easy-loan",

    //payrollLoan
    PAYROLL_LOAN_CRIBE_CONST: "PERSONAL_LOAN",
    PAYROLL_LOAN_NO_RECORD_MESSAGE: 'No existe ningún préstamo con los datos indicados.',
    PENDING_LOAN_ERROR: 'CONTRATO PDTE. DE CONSOLIDAR. INTENTAR MAÑANA',
    MAX_LENGTH_TITLE_UPLOAD_COMPONENT: 30,
    MAX_UPLOAD_EXPENSES_COMPONENTS: 10,
    VERSION_2: 2,
    FILE_TYPES: ['pdf', 'jpg', 'jpeg', 'png'],
    MAXIMUM_VALUE_YEARS_SENORITY: 50,
    MAXIMUM_VALUE_MONTHS_SENORITY: 11,

    payrollLoanJobTypeKeys: {
        PENSIONER_DRAGO_OPTION_KEY: 'pensionista',
        RENTER_DRAGO_OPTION_KEY: 'rentista',
        RETIRED_DRAGO_OPTION_KEY: 'jubilado',
        STUDENT_DRAGO_OPTION_KEY: 'estudiante',
        UNEMPLOYED_DRAGO_OPTION_KEY: 'desempleado',
        OWN_ACCOUNT_DRAGO_OPTION_KEY: 'cuenta_propia',
    },

    payrollLoanRecordStatus: {
        contractStatus: {
            APPROVED: 'APROBADO',
            MEJOR_OFERTA: 'MEJOR_OFERTA',
            NUEVA_OFERTA: 'NUEVA_OFERTA'
        },
        deniedStatus: {
            DENIED: 'DENEGADO',
            DENEGADO_TRAS_PREAPROB: 'DENEGADO_TRAS_PREAPROB',
            DENEGADO_TRAS_APROB: 'DENEGADO_TRAS_APROB'
        },
        requestStatus: {
            APORTAR_DOC: 'APORTAR_DOC',
            CANCELED: 'CANCELADO',
            DENEGADO_ANTES_PREAPROB: 'DENEGADO_ANTES_PREAPROB',
            ERROR_DOCUMENTACION: 'ERROR_DOCUMENTACION',
            KOxDTI: 'KO_DTI',
            KOxDTI2: 'KO-DTI',
            PRE_APROB: 'PRE_APROB',
            PRE_APPROVAL_OK: 'OK',
            SIMUL: 'SIMUL'
        },
        DOC_PTE_VALIDAR: 'DOC_PTE_VALIDAR',
        NO_RECORD: 'NO_RECORD'
    },

    easyLoanRecordStatus: {
        contractStatus: {
            APPROVED: 'APROBADO',
            MEJOR_OFERTA: 'MEJOR_OFERTA',
            NUEVA_OFERTA: 'NUEVA_OFERTA'
        },
        deniedStatus: {
            DENIED: 'DENEGADO',
            DENEGADO_TRAS_PREAPROB: 'DENEGADO_TRAS_PREAPROB',
            DENEGADO_TRAS_APROB: 'DENEGADO_TRAS_APROB'
        },
        requestStatus: {
            APORTAR_DOC: 'APORTAR_DOC',
            CANCELED: 'CANCELADO',
            DENEGADO_ANTES_PREAPROB: 'DENEGADO_ANTES_PREAPROB',
            ERROR_DOCUMENTACION: 'ERROR_DOCUMENTACION',
            KOxDTI: 'KO_DTI',
            KOxDTI2: 'KO-DTI',
            PRE_APROB: 'PRE_APROB',
            PRE_APPROVAL_OK: 'OK',
            PRE_APPROVAL_KO: 'KO',
            SIMUL: 'SIMUL'
        },
        DOC_PTE_VALIDAR: 'DOC_PTE_VALIDAR',
        NO_RECORD: 'NO_RECORD'
    },

    multichannelAlias: {
        PAYROLL_LOAN_ALIAS: 'payroll_loan_generic',
        MORTGAGE_GENERIC_ALIAS: 'mortgage_generic'
    },

    payrollLoanCommon: {
        FINANCIADA: 'FINACIADA           ', //we need to send to backend 20 chars.
        NO_FINANCIADA: 'NO FINANCIADA       ', //we need to send to backend 20 chars.
        TERM_STEP_VALUE: 1,
        AMOUNT_STEP_VALUE: 50,
        PRODUCT_TYPE: 2,
        ASNEFKO: 'KO',
        SPLIT_PURPOSES_ITEMS: 4,
    },

    payrollLoanJobs: {
        PAYROLL_LOAN_JOB_PERMANENT_EMPLOYEE: '01',
        PAYROLL_LOAN_JOB_TEMPORAL_EMPLOYEE: '02',
        PAYROLL_LOAN_JOB_STATE_EMPLOYEE: '03',
        PAYROLL_LOAN_JOB_INTERNAL_STATE_EMPLOYEE: '04',
        PAYROLL_LOAN_JOB_PENSIONER: '05',
        PAYROLL_LOAN_JOB_AUTONOMOUS: '06',
        PAYROLL_LOAN_JOB_OTHER: '07'
    },

    payrollLoanHouseRegime: {
        PAYROLL_LOAN_HOUSE_REGIME_RENTED_PROPERTY: '01',
        PAYROLL_LOAN_HOUSE_REGIME_FAMILY_PROPERTY: '02',
        PAYROLL_LOAN_HOUSE_REGIME_MORTGAGED_PROPERTY: '03',
        PAYROLL_LOAN_HOUSE_REGIME_TAXLESS_PROPERTY: '04',
        PAYROLL_LOAN_HOUSE_REGIME_OTHER: '05'
    },

    payrollLoanCivilStatus: {
        PAYROLL_LOAN_CIVIL_STATUS_MARRIED: 'C',
        PAYROLL_LOAN_CIVIL_STATUS_DIVORCED: 'D',
        PAYROLL_LOAN_CIVIL_STATUS_SEPARATED: 'E',
        PAYROLL_LOAN_CIVIL_STATUS_SINGLE: 'S',
        PAYROLL_LOAN_CIVIL_STATUS_WIDOWED: 'V'
    },

    payrollLoanLayoutKOxDTI: {
        MIN_TERM: 12,
        MAX_TERM: 60,
        MAX_AMOUNT: 24000,
        MAX_AMOUNT_COLLECTIVE: 30000,
        BIGGER_OFFER_VALUE: 200
    },

    payrollLoanUserType: {
        ML: 'ML'
    },

    payrollLoanTypeUpload: {
        IRPF_FILE: "irpfFile",
        PAYROLL_LOAN_CERTIFICATE: "payrollLoanCertificate",
        ADITIONAL_EXPENSES_FILES: "aditionalExpensesFiles",
        FILE_FIRST_INDEX: 0
    },

    easyLoanTypeUpload: {
        IRPF_FILE: "IRPF_FILE",
        IRPF130_FILE: "IRPF130_FILE",
        IRPF100_CLI_FILE: "IRPF100_CLI_FILE" || "IRPF100",
        IRPF100_FILE: "IRPF100",
        IRPF100_CLI_FILE_2: "IRPF100_CLI_FILE_2",
        IRPF100_CLI_FILE_3: "IRPF100_CLI_FILE_3",
        IRPF100_CLI_FILE_4: "IRPF100_CLI_FILE_4",
        EASY_LOAN_CERTIFICATE: "EASY_LOAN_CERTIFICATE",
        FILE_FIRST_INDEX: 0
    },

    payrollLoanErrorDocument: {
        NOM_VL: "NOM_VL",
        IRPF100: "IRPF100",
        RECEIPT: "RECEIPT",
        PEND_VAL: "PEND_VAL",
        NO_VALIDO: "NO_VALIDO"
    },

    easyLoanErrorDocument: {
        NOM_VL: "NOM_VL",
        IRPF100: "IRPF100",
        IRPF130: "IRPF130_PREST",
        NEW_IRPF100_FILE: "IRPF100",
        IRPF100_CLI: "303_PREST_1",
        IRPF100_CLI_2: "303_PREST_2",
        IRPF100_CLI_3: "303_PREST_3",
        IRPF100_CLI_4: "303_PREST_4",
        RECEIPT: "RECEIPT",
        PEND_VAL: "PEND_VAL",
        NO_VALIDO: "NO_VALIDO"
    },
    payrollLoanDataPrecontractualEmail: {
        PRODUCT: "143",
        STANDARD: "001",
        SUBPRODUCT: "804",
        TEMPLATE_CODE: "payroll_loan_precontractual"
    },

    payrollLoanDataAsnef: {
        ASNEF_PRODUCT: "143",
        ASNEF_STANDARD: "0000001",
        ASNEF_SUBPRODUCT: "804",
    },

    //RetailLoan
    retailLoanCommons: {
        DATE_PICKER_CUSTOM_DATE_FORMAT: 'DD MMM YYYY',
        FORMAT_DATE_DELIVERY: 'DD MMM',
        FORMAT_DATE_DELIVERY_MONTH: 'DATE_FORMAT_DAY_MONTH',
        STATUS_OK: 'OK',
        TEXT_AREA_MAX_LENGTH: 250,
        YES: 'si',
        NO: 'no',
        PRODUCT_TYPE: 3,
        LANGUAGE_ID: '1',
        TIME_UNIT: 'M',
        PURPOSE: '99',
        PRICE_TYPE: 'E',
        CHANNEL: 'RED',
        BANNERID: 'B.18.1',
        MODAL_VIEWER_HEIGHT: 20,
        SPLIT_RETAIL_PRODUCTS: 4,
        COUNTRY: 'España',
        STORE_PICKUP: 'STORE_PICKUP',
        ADDRESS_DELIVERY: 'ADDRESS_DELIVERY',
        RETAIL_LOAN_PRECONTRACTUAL: 'retail_loan_precontractual',
        NEW_RETAIL_LOAN_PRECONTRACTUAL: 'precontractual',
        NEW_RETAIL_LOAN_CONTRACT: 'contract'

    },

    retailLoanProposition: {
        FORMALIZE_OPERATION: '124',
        TRANSFER_OPERATION: '1'
    },

    retailLoanGallery: {
        POSITION_RIGHT: "right",
        MAIN_IMAGE_WIDTH: 150,
        MAIN_IMAGE_WIDTH_IN_INFO: 300,
        MAIN_IMAGE_WIDTH_CATALOG_MODAL: 260,
        MAIN_IMAGE_SCALE: 2,
        MAIN_IMAGE_SCALE_INFO: 1.5,
        MAIN_IMAGE_RIGHT: 140,
        MAIN_IMAGE_LEFT: -510,
        MAIN_IMAGE_TOP: -50,
        MAIN_IMAGE_MODAL_TOP: -15,
        MAIN_IMAGE_MODAL_RIGHT: 100
    },

    retailLoanDoTaggin: {
        NAME_PRODUCT: "prestamo-compra",
        TEALIUM_EVENT: "product_impression",
        OPEN_MARKETS: "open-markets",
        STANDARD: "standard",
        PRODUCT_NAME_CLICK: "product_click",
        PRODUCT_IMAGE_VIEW: "ver fotos",
        PRODUCT_SPECIFICATIONS_VIEW: "product_view",
        PRODUCT_SPECIFICATIONS_CONTINUE: "continuar",
        LOAD_MODAL_TERMS_CONDITIONS: "modal documentacion",
        TAGGING_TERMS_AND_CONDITIONS: "terminos y condiciones",
        TAGGING_VIEW: "vista",
        TAGGING_CONTINUE: "continuar",
        TAGGING_EXIT: "salir",
        TAGGING_CLOSE: "cerrar",
        TAGGING_PRINT: "imprimir",
        TAGGING_ACCEPT: 'acepto',
        TAGGING_POLITICS: 'politica',
        TAGGING_BACK: 'volver',
        TAGGING_DOWNLOAD: "descargar",
        TAGGING_OK: "entendido",
        TAGGING_SAVE: "guardar",
        TAGGING_START: "inicio",
        TAGGING_STEP_2: "paso_2",
        TAGGING_PURCHASE: "purchase",
        TAGGING_CHECKOUT: "checkout",
        TAGGING_QUANTITY: "1",
        TAGGING_MONTHS: " months",
        TAGGING_VIEW_INE: " Ver Información Normalizada Europea (INE)",
        TAGGING_CANCEL: "cancelar",
        TAGGING_NEXT: "siguiente",
        TAGGING_SWITCH: "switch",
        TAGGING_CONFIRM: "confirmar",
        TAGGING_LOAD_EMAIL_MODAL: "modal modifica email",
        TAGGING_LOAD_NEW_ADDRESS: "modal nueva direccion",
        TAGGING_LOAD_BILLING_ADDRESS: "modal nueva facturacion",
        TAGGING_SHOW_MODAL: 'modal-cesion-de-datos',
        TAGGING_SHOW_MODAL_ERROR: 'modal-cesion-de-datos/error',
        TAGGING_MODIFY_CONSENT: 'proc-cesion-de-datos',
        TAGGING_GDPR_RIGHTS_DATA_PROTECTION: "tus derechos y protección de datos",
        NAME_PAGE_CATALOG_VIEW: "catalogo/prestamo-compra",
        NAME_PAGE_SPECIFICATIONS_VIEW: "catalogo/prestamo-compra/producto",
        NAME_PAGE_WIZARD_VIEW: "contratacion/prestamo-compra",
        FORMALIZE_ERROR: "404",
    },

    segmentedType: {
        EASY_LOAN_ID: '01',
        RETAIL_LOAN_ID: '03',
        CARDS_LOAN_ID: '05'
    },

    segmentedStatuses: {
        STATUS_NOT_SEGMENTED: '0',
        STATUS_SEGMENTED: '1',
        STATUS_SEGMENTED_BUT_UNOBTAINABLE: '2',
    },

    configOkLoans: (formatText, item, currency) => {
        const provider = item.getIn(['field_retail_provider', 'provider']);
        const minimumQuota = getFormattedString({
            amount: item.get('field_value_minimum_quota'),
            currency,
            decimalsLength: decimalsLength(item.get('field_value_minimum_quota'))
        });

        return {
            warningMessage: formatText('retailLoanCatalog-termsAndConditionsWarningMessage'),
            linkTermsAndConditions1: formatText('retailLoanCatalog-linkTermsAndConditions1'),
            linkTermsAndConditions2: formatText('retailLoanCatalog-linkTermsAndConditions2'),
            dateEstimatedDelivery1: formatText('retailLoanCatalog-retailLoanCatalog_dateEstimatedDelivery1'),
            dateEstimatedDelivery2: formatText('retailLoanCatalog-dateEstimatedDelivery2'),
            dateEstimatedDelivery3: formatText('retailLoanCatalog-dateEstimatedDelivery3'),
            dateEstimatedDelivery4: formatText('retailLoanCatalog-retailLoanCatalog_dateEstimatedDelivery4'),
            dateEstimatedDelivery5: formatText('retailLoanCatalog-retailLoanCatalog_dateEstimatedDelivery5', [minimumQuota]),
            pickUpIn: formatText('retailLoanCatalog-retailLoanCatalog_pickUpIn'),
            concessionaire: formatText('retailLoanCatalog-retailLoanCatalog_concessionaire', [provider]),
            moreInformation: formatText('retailLoanCatalog-moreInformation'),
            continue: formatText('retailLoanCatalog-continue'),
            title: formatText('retailLoanCommon-specs', [item.get('title')]),
            deliveryDate: item.get('deliveryDate')
        }
    },

    configOkLoansCarousel: (formatText) => {
        return {
            subtitleDateEstimatedDelivery1: formatText('retailLoanCatalog-subtitleDateEstimatedDelivery1'),
            subtitleDateEstimatedDelivery2: formatText('retailLoanCatalog-subtitleDateEstimatedDelivery2'),
            euroSymbol: EURO_SYMBOL
        }
    },

    provincesExcludeFromInput: {
        CEUTA: 'Ceuta',
        MELILLA: 'Melilla',
        CANARIAS: 'Canarias',
        SANTA_CRUZ_DE_TENERIFE: 'Santa Cruz De Tenerife',
        LAS_PALMAS: 'Las Palmas',
        EL_HIERRO: 'El Hierro',
        LA_GOMERA: 'La Gomera',
        LA_PALMA: 'La Palma',
        TENERIFE: 'Tenerife',
        GRAN_CANARIA: 'Gran Canaria',
        FUERTEVENTURA: 'Fuerteventura',
        LANZAROTE: 'Lanzarote',
        LA_GRACIOSA: 'La Graciosa',
        MONTANA_CLARA: 'Montaña Clara',
        ALEGRANZA: 'Alegranza',
        ROQUE_DEL_ESTE: 'Roque del Este',
        ROQUE_DEL_OESTE: 'Roque del Oeste',
        ISLOTE_DE_LOBOS: 'Islote de Lobos',
        SALMOR: 'Salmor',
        FASNIA: 'Fasnia',
        GARACICO: 'Garachico',
        ANAGA: 'Anaga'
    },

    //contractEasyLoan

    contractEasyLoan: {
        contractEasyLoanEmail: {
            TEMPLATE_CODE: "preapproved_loan_precontractual",
        },
        PAYMENT_DAY_END_OF_MONTH: 'PAYMENT_DAY_END_OF_MONTH',
        PAYMENT_DAY_OTHER: 'PAYMENT_DAY_OTHER',
        PURPOSE_BUY_VEHICLE: 'PURPOSE_BUY_VEHICLE',
        PURPOSE_FIX_HOUSE: 'PURPOSE_FIX_HOUSE',
        PURPOSE_HOME_ELEMENTS: 'PURPOSE_HOME_ELEMENTS',
        PURPOSE_STUDIES: 'PURPOSE_STUDIES',
        PURPOSE_HEALTH: 'PURPOSE_HEALTH',
        PURPOSE_TRAVEL: 'PURPOSE_TRAVEL',
        PURPOSE_OTHER: 'PURPOSE_OTHER',
        PRODUCT_TYPE: 1,
        LANGUAGE: 1,
    },

    contractEasyLoanTypeC: {
        PURPOSE_BUY_VEHICLE_TEXT: 'purposeBuyVehicle',
        PURPOSE_FIX_HOUSE_TEXT: 'purposeFixHouse',
        PURPOSE_HOME_ELEMENTS_TEXT: 'purposeHomeElements',
        PURPOSE_STUDIES_TEXT: 'purposeStudies',
        PURPOSE_HEALTH_TEXT: 'purposeHealth',
        PURPOSE_TRAVEL_TEXT: 'purposeTravel',
        PURPOSE_OTHER_TEXT: 'purposeOther'
    },

    easyLoanTypeCLaborFields: {
        OUTCOME: 'outcome',
        INCOME: 'income',
        EXPENSES: 'expenses',
        RENTAL: 'rental'
    },

    //loanPartialAmortization

    amortizationTypes: {
        ADVANCE_END_DATE: 'advanceEndDate',
        DECREASE_FEE: 'decreaseFee',
        CONTRACT_TYPE: 60,
        YES: 'S',
        NO: 'N'
    },

    loanPurposes: {
        PURPOSE_BUY_VEHICLE: "COMPRA DE VEHÍCULO",
        PURPOSE_FIX_HOUSE: "REFORMA DE VIVIENDA",
        PURPOSE_HOME_ELEMENTS: "ELEMENTOS DE HOGAR",
        PURPOSE_STUDIES: "ESTUDIOS",
        PURPOSE_HEALTH: "SANIDAD",
        PURPOSE_TRAVEL: "VIAJES",
        PURPOSE_OTHER: "OTROS"
    },

    preGrantedCredit: {
        MIN_VALUE_REQUEST_AMOUNT: 300,
        MAX_VALUE_REQUEST_AMOUNT: 12000,
        OPERATION_TYPE: 74,
        MULTI_OTP_MESSAGE_CODE: 32,
        LANGUAGE: 1,
        CONTRACT_NAME: "pre-granted-credit",
        preGrantedCreditEmail: {
            PRODUCT: "999",
            SUBPRODUCT: "999",
            STANDARD: "0000001",
            TEMPLATE_CODE: "bare_protection_precontractual",
        },
    },

    uploadFile: {
        MAX_SIZE_FILE: 5000,
        NAME_LENGTH: 40
    },

    YEAR_MONTHS: 12,
    EASY_LOAN_TYPEC_CRIBE_CONST: "PREAPROBADO_C",
    LOAN_PDF_TIMEOUT: 1000,
    RETAIL_LOAN_FULL_IMAGE_SIZE_ADJUSTMENT: 20,
    INE_DOCUMENT: 'INE_DOCUMENT',
    CONTRACT_DOCUMENT: 'CONTRACT_DOCUMENT',
    CONTRACT_DOCUMENT_NAME: 'contract_draft',
    INE_DOCUMENT_NAME: 'INE_document',
    PRE_APPROVED_DOCUMENT: 'PRE_APPROVED_DOCUMENT',
    SERVICE_CONTRACT_FOR_PHYSICAL_PERSONS: "https://www.openbank.es/assets/static/pdf/Pie%20de%20P%C3%A1gina/Contrato%20de%20prestacion%20de%20servicios%20de%20personas%20fisicas.pdf",
    INTERSTITIAL_PD_DOCUMENT: 'INTERSTITIAL_PD_DOCUMENT',
    INTERSTITIAL_ODM_DOCUMENT: 'INTERSTITIAL_ODM_DOCUMENT',
    INTERSTITIAL_PD_DOCUMENT_DOWNLOAD_LINK: 'https://www.openbank.es/politica',
    INTERSTITIAL_ODM_DOCUMENT_DOWNLOAD_LINK: 'https://www.openbank.es/assets/static/pdf/OpenMarkets/Politica_de_privacidad_ODM.pdf',
    PAYROLL_LOAN_DATA_PROTECTION_DOCUMENT_LINK: 'https://www.openbank.es/assets/static/pdf/Productos/Otros/Proteccion_datos_prestamo_personal.pdf',
    LOGO_OPEN_DIGITAL_MARKETS: 'https://www.openbank.es/assets/loans/open-digital.png',
    RETAIL_LOAN_CONSENTS_STATUS: {
        ACCEPTED: 'ACCEPTED',
        PENDING: 'PENDING',
        NOT_ACCEPTED: 'NOT_ACCEPTED'
    },
    RETAIL_LOAN_PLACEMENT_ID: 'openmarkets',
    PAYROLL_LOAN_PRE_APPROVED_STATUS: {
        SERVICE_ERROR: "error servicio",
        DENIED: "denegacion",
        ASNEF_VALIDATION_ERROR: 422,

    },
    RETAIL_LOAN_CONSENTS_ID: {
        INTERSTITIAL_CONSENT_ID: '01',
        AMAZON_CONSENT_ID: '02'
    },
    LOANS_SUBTYPE: {
        TYPE_C: '810'
    },
    VIEWER_HEIGHT_INE_PDF: 650,
    CONTRACT_EASY_LOAN_CATEGORY_EVENT: "proc-contratacion-prestamo-nomina",
    TAG_EVENT_OPEN: "open",
    TAG_EVENT_CLOSE: "close",
    CLICK_BUTTON_ACTION: "clickButton",
    CLICK_LINK_EVENT: "clickLink",
    TAG_DOWNLOAD: "download",
    TAG_PRINT: "print",
    TAG_PREVIOUS: "previous",
    EMPLOYER_WITH_SALARIES: "empresario_con_salarios",
    EMPLOYER_WITHOUT_SALARIES: "empresarios_y_comerciantes_sin_asalariados",
    LIBERAL_PROFESSIONALS: "profesionales_liberales",
    FARMERS_AND_LIVESTOCK_BREEDERS: "agricultores_y_ganaderos_(no_jornaleros)",
};


